/**
 * Stack of "lesson unlocked" toasts. Auto-dismisses each toast after 4 s,
 * clears the store queue when the user taps to acknowledge.
 */
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect } from 'react';
import { useGameStore } from '../stores/game.js';
import styles from './LessonToastStack.module.css';

const AUTO_DISMISS_MS = 4_000;

export function LessonToastStack(): JSX.Element {
  const lessons = useGameStore((s) => s.recentlyUnlockedLessons);
  const acknowledge = useGameStore((s) => s.acknowledgeLessons);

  useEffect(() => {
    if (lessons.length === 0) {
      return undefined;
    }
    const id = window.setTimeout(() => {
      acknowledge();
    }, AUTO_DISMISS_MS);
    return () => {
      window.clearTimeout(id);
    };
  }, [lessons, acknowledge]);

  return (
    <div className={styles.stack} aria-live="polite">
      <AnimatePresence>
        {lessons.map((lesson) => (
          <motion.div
            key={lesson.id}
            className={styles.toast}
            initial={{ opacity: 0, y: -20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, x: 40 }}
            transition={{ duration: 0.4, ease: 'easeOut' }}
            onClick={acknowledge}
          >
            <span className={styles.label}>урок</span>
            <span className={styles.title}>{lesson.title}</span>
            <span className={styles.bonus}>+{Math.round(lesson.bonus * 100)}%</span>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
